// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  COMPANY_LABEL: 'Train Company',
  COMPANY_PLACEHOLDER: 'Select your train company',
  TRAIN_LABEL: 'Train',
  TRAIN_PLACEHOLDER: 'Click to find your train',
  TRAIN_LIGHTBOX_TITLE: 'Find Your Train',
  FIND_TRAIN: 'Search',
  ORIGIN_STATION: 'Origin Station',
  DESTINATION_STATION: 'Destination Station',
  ORIGIN_STATION_PLACEHOLDER: 'Select origin station',
  DESTINATION_STATION_PLACEHOLDER: 'Select destination station',
  NO_TRAINS_FOUND:
    "We are sorry, but we didn't find any trains by your request",
  TRAIN_DATE_PLACEHOLDER: 'Select date',
  TRAIN_DATE_LABEL: 'Date of your trip',
  TRAIN_OPTIONS: 'Found trains',
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_FORM_TRAIN_FIELD',
  MESSAGES
)
